import { computed, effect, Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ThemeService {
  private readonly STORAGE_KEY = 'theme';
  private readonly darkModeState = signal<boolean>(this.loadInitialTheme());

  public readonly isDark = computed(() => this.darkModeState());

  constructor() {
    effect(() => {
      const dark = this.darkModeState();
      if (dark) {
        document.documentElement.classList.add('dark');
      } else {
        document.documentElement.classList.remove('dark');
      }
      localStorage.setItem(this.STORAGE_KEY, dark ? 'dark' : 'light');
    });
  }

  public toggle(): void {
    this.darkModeState.update(v => !v);
  }

  private loadInitialTheme(): boolean {
    const stored = localStorage.getItem(this.STORAGE_KEY);
    const isDark = stored === 'dark';
    // Apply synchronously so the class is on <html> before any component renders.
    // This runs during service construction (signal field initializer), which happens
    // at app bootstrap because ThemeService is eagerly injected in AppComponent.
    if (isDark) {
      document.documentElement.classList.add('dark');
    }
    return isDark;
  }
}
